import {
    get_tipologie,
    create_tipologia,
    update_tipologia,
    delete_tipologia,
} from "@/api/api.tipologie.js";

const tipologie = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_tipologie().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        crea({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_tipologia(dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiorna({ dispatch }, { id, dati }) {
            return new Promise((resolve, reject) => {
                update_tipologia(id, dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_tipologia(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default tipologie;
